"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _UserValidator = require("./UserValidator");
Object.keys(_UserValidator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UserValidator[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _UserValidator[key];
    }
  });
});